/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    updateRetryCalculateShippingAttempt,
    clearCalculateShippingAttempt,
    updateCalculateShippingApplied,
} from './CalculateCart-Actions';

const initialState = {
    calShippingChargesAttempt: 0,
    calShippingApplied: false,
};

const calculateShippingReducer = (state = initialState, action) => {
    switch (action.type) {
        case updateRetryCalculateShippingAttempt().type:
            return {
                ...state,
                calShippingChargesAttempt: state.calShippingChargesAttempt + 1,
            };
        case clearCalculateShippingAttempt().type:
            return {
                ...state,
                calShippingChargesAttempt: 0,
            };
        case updateCalculateShippingApplied().type:
            return {
                ...state,
                calShippingApplied: action.data,
            };
        default:
            return state;
    }
};

export default calculateShippingReducer;
